import React from 'react';
import { Button, Typography, Result } from 'antd';
import { useNavigate } from 'react-router-dom';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '80vh' }}>
      <Result
        status="404"
        title="404 - Page non trouvée"
        subTitle="Désolé, la page que vous recherchez n'existe pas ou a été déplacée."
        extra={
          <Button type="primary" onClick={() => navigate('/')}>
            Retour à l'accueil
          </Button>
        }
      />
    </div>
  );
};

export default NotFound;
